import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const LocalizationTextOverrideInputSchema_ = z.object({
  localizationObjectId: z.string(),
  path: z.string(),
  text: z.string(),
});

export const LocalizationTextOverrideInputSchema: z.ZodType<LocalizationTextOverrideInputSchema> =
  LocalizationTextOverrideInputSchema_;
export interface LocalizationTextOverrideInputSchema
  extends z.infer<typeof LocalizationTextOverrideInputSchema_> {}

export const saveLocalizationTextOverrides = {
  name: "saveLocalizationTextOverrides" as const,
  input: z.object({
    teamId: zExt.objectId(),
    localizationGroupId: zExt.objectId(),
    textOverrides: z.array(LocalizationTextOverrideInputSchema),
  }),
  output: z.object({ success: z.boolean() }),
};
